export default __webpack_public_path__ + "static/media/Offre_connaissance.d35d00d8.jpg";